<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="セガのプリクラ機『lalamee（ララミー）』『ROMAPI（ろまぴ）』と「BE:FIRST（ビーファースト）」のコラボ決定！"/>
    <div data-v-3c4f816c="">
      <div data-v-3c4f816c="" class="text-area">
        22.09.09<br><br>
        セガのプリクラ機『lalamee（ララミー）』『ROMAPI（ろまぴ）』と「BE:FIRST（ビーファースト）」のコラボ決定！<br><br>
        <center><img src="@/assets/Png/News/BEFIRST/BEFIRST_01.jpg" style="max-width: 70%;"></center>
        <br><br>
        <b>■実施期間</b>
        <br><br>2022年9月15日（木）～2022年11月7日（月）<br><br>
        <b>■対象機種</b>
         <br><br>『lalamee（ララミー）』『ROMAPI（ろまぴ）』<br><br>
         <center><img src="@/assets/Png/News/BEFIRST/lalamee_CG.png" style="max-width: 50%;"><img src="@/assets/Png/News/BEFIRST/ROMAPI_CG.png" style="max-width: 50%;"></center><br><br>
         <center>『lalamee（ララミー）』設置店舗は<a href="https://o.puri.jp/appfw/locationLalamee/">こちら</a></center>
         <center>『ROMAPI（ろまぴ）』設置店舗は<a href="https://o.puri.jp/appfw/locationRomapi/">こちら</a></center><br><br>全国30台限定！<br>BE:FIRST特別デザインの『ROMAPI』も登場！<br><br>
         <center><img src="@/assets/Png/News/BEFIRST/BEFIRST_03.png" style="max-width: 100%;"></center><br><br>
         <center>特別デザインの設置店舗は<a href="https://puri.sega.jp/info/befirst/">コラボ特設サイト</a></center><br><br>
        <b>■内容</b>
         <br><br>●BE:FIRSTメンバーと一緒に撮影！<br>うごく撮影フレーム”が、lalameeは24種、ROMAPIは28種！<br>すべてプリクラ専用に撮影したオリジナルカット！<br><br>メンバーと一緒に3秒動画「モーメント」も撮影できる♪<br>もちろん、撮影したデータは「プリクラON」にダウンロード可能。<br>※有料会員なら全データダウンロード可能<br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_movie_01.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_moment01.mp4"></video></center><br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_movie_02.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_moment02.mp4"></video></center><br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_movie_03.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_moment03.mp4"></video></center><br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_movie_04.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_moment04.mp4"></video></center><br><br>●「ARプリクラ」でもBE:FIRSTがうごく！<br><br>撮影したシールを「プリクラON」のカメラで見るとシールが動きます！<br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_AR01.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_AR.mp4"></video></center><br><br>※ホーム画面左上にある「AR」ボタンを押すと専用のカメラが起動します。<br>※ARプリクラはアプリ版プリクラONでのみご利用可能です。<br>
         <center><img src="@/assets/Png/News/BEFIRST/home_ar.png" style="max-width: 70%;"></center><br><br>●BE:FIRSTのBGMで盛り上がろう！<br><br>1stアルバム「BE:1」にも収録されている最新曲<br>『Scream』など計5曲！<br><br>『Scream』『Bye-Good-Bye』『Gifted.』<br>『Betrayal Game』『Shining One』が聴ける♪<br><br>撮影中やらくがき中の気分も上がること間違いなし！<br><br>BE:FIRST 1stアルバム「BE:1」 Now On Sale！<br><br>
         <center><img src="@/assets/Png/News/BEFIRST/BEFIRST_CD.png" style="max-width: 70%;"></center><br><br>●コラボ限定「プリもっと」はメッセージ付き！<br>メンバー１人1人からのメッセージボイスが込められた「プリもっと」は全8種。<br>※9/15（木）AM10時から登場です。<br><br>
         <center><video controls="" poster="@/assets/Png/News/BEFIRST/BEFIRST_purimotto.png" width="200" height="200" src="@/assets/Png/News/BEFIRST/BEFIRST_purimotto.mp4"></video></center><br><br>
        <b>「プリもっと」の遊び方</b>
        <br><br>
        <center>ホーム画面左上にある「プリもっと」ボタンを<br>押してご利用ください。<br>※プリもっとはアプリ版プリクラONでのみご利用可能です。</center><br>
        <center><img src="@/assets/Png/News/BEFIRST/home.png" style="max-width: 70%;"></center><br>
        <center>デザインを選んで編集しよう！<br></center>
        <center><img src="@/assets/Png/News/BEFIRST/purimotto_tut_c2.jpg" style="max-width: 70%;"></center><br>
        <center>作ったプリもっとを獲得しよう！</center>
        <center><img src="@/assets/Png/News/BEFIRST/purimotto_tut_c3.jpg" style="max-width: 70%;"></center>
        <center>プリクラ機にQRをかざそう！</center>
        <center><img src="@/assets/Png/News/BEFIRST/purimotto_tut_c4.jpg" style="max-width: 70%;"></center><br>
        <center>プリクラ機で使用できるよ！</center>
        <center><img src="@/assets/Png/News/BEFIRST/purimotto_tut_c1.jpg" style="max-width: 70%;"></center><br><br>●スタンプにもコラボデザイン登場！<br><br>メンバーの名前やBE:FIRSTのロゴがスタンプに！<br><br>
        <center><img src="@/assets/Png/News/BEFIRST/BEFIRST_04.png" style="max-width: 80%;"></center><br>
        <b>■プレゼントキャンペーン</b>
        <br><br>先着で「BE:FIRSTステッカー」をプレゼント。<br>キャンペーン期間中、『lalamee』か『ROMAPI』で撮影するともらえるよ。<br><br>
        <center><img src="@/assets/Png/News/BEFIRST/BEFIRST_05.png" style="max-width: 80%;"></center><br><br>
        <center>詳細は<a href="https://puri.sega.jp/info/befirst/">コラボ特設サイト</a></center><br><br>
        <b>■プリクラコラボのBE:FIRSTメイキング映像公開！</b>
        <br><br>プリクラコラボでの撮影＆収録のメイキング映像を、有料会員限定で公開します。<br>オフショットもたくさん、魅力たっぷりのメイキング映像をご覧ください。<br>無料視聴版もあります。<br>※9/15（木）AM10時から公開です。<br>
        <center>メイキング映像の詳細は<a href="https://puri.sega.jp/info/befirst/">こちら</a></center><br><br>コラボ特設サイト、セガ公式SNSでもコラボ情報を発信中！<br><br>
        <center>コラボ特設サイトは<a href="https://puri.sega.jp/info/befirst/">こちら</a></center><br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
        </div>
        <div class="centerBlock">
          <a href="https://www.instagram.com/sega_purikura/">Instagram</a>
          <a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
          <a href="https://lin.ee/BncFzGc">LINE</a>
        </div><br><br>
        <center>ⓒ2022 BMSG, Inc.</center>
      </div>
    </div>
    <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
    <sub-btn @click="onHome()">ホームに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: {SectionHeader, SubBtn},
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;
    img {
      max-width: 100%;
    }
    .edge {
      box-shadow: 0 0 5px rgba(0,0,0,0.12);
    }
    p {
      margin-top: 1em;
    }
    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }
    .centerBlock {
      display: flex;
      justify-content: center;
      & > a:not(:first-of-type) { margin-left: 24px; }
    }
  }
  .sns {
    a { margin: 0 3px; }
  }
}
</style>
